<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    :close-on-click-modal = 'false'
    :show-close ='false'
    center>
    <img class="closeimg" src="@/assets/image/close.png" @click="centerDialogVisible = false"/>
    <h2>終止出餐</h2>
    <p style="margin-bottom: 5px">1. 請選擇欲終止前的「最後一次用餐日期及餐期」。</p>
    <p style="margin-top: 0">2. 提醒您 ! 若您確認終止出餐，恢復訂餐請重新建立新訂單。</p>
    <div class="roomBody">
       <div class="original">
          <div>
             <h3>{{ canObj.agency_room_info?canObj.agency_room_info.name:''}}</h3>
             <h3>{{ canObj.user_name }}</h3>
          </div>
         <span>原訂出餐期間</span>
         <p>{{ (canObj.start_date?canObj.start_date.replaceAll('-','/'):'')+' - '+(canObj.end_date?canObj.end_date.replaceAll('-','/'):'')  }}</p>
       </div>
      <div class="originalTwo">
          <div>
             <span>終止日期</span>
            <el-date-picker
              type="date"
              placeholder="選擇日期"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              :picker-options="startPickerOptions"
            >
            </el-date-picker>
          </div>
        <div>
          <span>終止餐期</span>
          <el-select placeholder="請選擇餐期">
            <el-option label="早餐" :value="1"></el-option>
            <el-option label="午餐" :value="2"></el-option>
            <el-option label="晚餐" :value="3"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
     <div @click="centerDialogVisible = false">取消填寫</div>
      <div>確認終止出餐</div>
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: "roomDig.vue",
  data(){
    return{
      centerDialogVisible: false,
      canObj:{},
      startPickerOptions: {
        disabledDate: (v) => {
          return (
            v.getTime() < new Date().getTime() - 8.64e7 ||
            v.getTime() > new Date(this.canObj.end_date).getTime()
          )
        }
      },
    }
  },
  methods:{
     init(item){
        this.canObj = item
        this.centerDialogVisible = true
     },

  }
};
</script>



<style scoped lang="scss">
::v-deep .el-dialog{
  width: 650px;
  border-radius: 15px;
  padding: 0;
  position: relative;
}
.closeimg{
  width: 30px;
  height: 30px;
  object-fit: contain;
  position: absolute;
  right: -40px;
  top: 10px;
  cursor: pointer;
}
::v-deep .el-dialog__footer{
  padding: 0;
  .dialog-footer{
     display: flex;
    align-items: center;
    div{
      flex: 1;
      background: #DBBD80;
      color: #FFFFFF;
      font-size: 20px;
      padding: 15px 20px;
      cursor: pointer;
      font-weight: bolder;
    }
    div:first-child{
      border-radius: 0 0 0 15px;
      border-right: 1px solid #FFFFFF;
    }
    div:last-child{
      border-radius: 0 0 15px 0px;
    }
  }

}

h2{
  font-size: 30px;
  font-weight: bolder !important;
  text-align: center;
  margin: 0;
  color: #DBBD80;
  padding-bottom: 20px;
  border-bottom: 1px solid #DBBD80;
}
p{
  font-size: 16px;
  color: #b6b8bd;
  text-align: start;
}

.roomBody{
   .original{
     padding: 20px 30px;
     border: 1px solid #DBBD80;
     border-radius: 15px;

     div{
        display: flex;
       align-items: stretch;
       letter-spacing: 2px;
       padding-bottom: 10px;
       margin-bottom: 20px;
       border-bottom: 1px solid #DBBD80;
       h3{
         font-size: 24px;
         color: #DBBD80;
         font-weight: bolder !important;
         margin: 0 20px 0px 0;
       }
     }
     p{
       letter-spacing: 2px;
       color: #000000;
       font-size: 20px;
       margin: 10px 0;
     }
     span{
       letter-spacing: 2px;
       color: #3C3C3C;
     }
   }
  .originalTwo{
      display: flex;
    align-items: stretch;
    gap: 20px;
    margin-top: 30px;
     div{
       flex: 1;
       span{
         display: inline-block;
         margin-bottom: 20px;
         padding: 5px 20px;
         background: #f5f5f5;
         border-radius: 25px;
         letter-spacing: 2px;
       }
       ::v-deep .el-input--suffix .el-input__inner{
         border: none;
         border-bottom: 1px solid #DCDFE6;
         border-radius: 0;
       }
     }
  }
}
</style>
